import React from 'react'
import {useTranslation} from 'react-i18next'

import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import {Box} from '@mui/material'
import {PGButton, PGTypography, PGModal} from '@progynyglobal/pg-ui-library'

type ConfirmationModalProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  content: string
  minWidth?: string | number
  className?: string
  dialogContentClassName?: string
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = (props) => {
  const {
    open,
    onClose,
    onConfirm,
    title,
    content,
    className,
    dialogContentClassName,
  } = props
  const {t} = useTranslation()

  return (
    <PGModal
      open={open}
      showCloseButton={false}
      onClose={onClose}
      title={title}
      className={className}
    >
      <Box>
        <PGTypography variant='body' className={dialogContentClassName}>
          {content}
        </PGTypography>
        <Box display={'flex'} gap={1} justifyContent={'flex-start'}>
          <PGButton
            variant='outlined'
            label={t('budget_reimbursement_documents_go_back')}
            startIcon={<KeyboardBackspaceIcon />}
            onClick={onClose}
          />
          <PGButton
            variant='contained'
            label={t('budget_partner_agreement_confirmation_modal_yes_submit')}
            onClick={onConfirm}
          />
        </Box>
      </Box>
    </PGModal>
  )
}

export default ConfirmationModal
